import { ContentBlockGallery, WidgetGallery } from '../../../common/types/api/page'
import { WidgetTypes } from '../../../../js/common/types/api/report'
import { ReactNode } from 'react'

interface Config {
    minHeight: number
    type: string
    Editor: any
}
export interface WrapperConfig extends Config {
    Preview: ReactNode
}
interface PropsTypeContext {
    [key: string]: WrapperConfig
}
// TODO: REMOVE
const types: PropsTypeContext = {}

export default function wrapperDecorator(config: Config): (Component: (props) => JSX.Element) => PropsTypeContext {
    // TODO: RESOLVE TYPE
    return (Component: any): PropsTypeContext => {
        types[config.type] = {
            ...config,
            Preview: Component
        }

        return types
    }
}
export const getGalleryContentType = (galleryContent: WidgetGallery|ContentBlockGallery): WidgetTypes => {
    if(galleryContent?.widgetId) {
        return WidgetTypes.GALLERY
    } else if(galleryContent?.content) {
        if(galleryContent?.content?.query || galleryContent?.content?.span) {
            return WidgetTypes.PIPES
        } else if (galleryContent?.content?.template) {
            return WidgetTypes.HTML
        }
    }
}

export const getTypes = (): string[] => Object.values(types).map((config: Config) => config.type)
export const getContentTypes = (): string[] =>
    Object.values(types)
        .map((config: Config) => config.type)
        .filter(value => value !== 'html')
        .reverse()

export const getPreview = (type: string): ReactNode => types[type].Preview
export const getWrapper = (type: string): WrapperConfig => types[type]
